export default "__VITE_ASSET__Bc1w9Q8V__"